export default __webpack_public_path__ + "static/media/calendar.cedb31f4.svg";